

























import Vue from 'vue';
import { setTimeout } from 'timers';

export default Vue.extend({
  name: 'app',
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    // hide loading indicator just in case updated isn't fired
    setTimeout(() => {
      this.isLoading = false;
    }, 15000);

  },
  updated() {
    this.$nextTick(() => {
      // Code that will run only after the
      // entire view has been re-rendered
      this.isLoading = false;
    });
  },
});
